import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [isAdvanced, setIsAdvanced] = useState(null);

  const value = {
    auth,
    setAuth,
    isAdvanced,
    setIsAdvanced,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
